exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-animated[data-v-50c3f4e3]{max-height:2000px;overflow:auto;overflow-y:scroll;-webkit-transition:max-height .5s ease-in-out,opacity .5s;transition:max-height .5s ease-in-out,opacity .5s}.disabled-group[data-v-50c3f4e3]{opacity:.25;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;user-focus:none;user-input:none;max-height:0;overflow-y:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50c3f4e3","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/vue/question-selector-enabler.vue
// module id = xVE7
// module chunks = 0